import { connect } from "react-redux";
import { Dispatch } from "redux";
import { isOnlineSelector } from "../../../../store/app.store";
import { RootState } from "../../../../store/index.store";
import { AssignGroupingKey, KeyValue } from "../../../../types/types";
import { assignPageSelectors } from "../../assign-page.selector";
import { assignPageActions } from "../../assign-page.store";
import { AssignCommandBar as AssignCommandBarComponent } from "./AssignCommandBar";

const mapStateToProps = (state: RootState) => ({
  nenki: assignPageSelectors.getNenki(state),
  selectedGroupingCondition: assignPageSelectors.getSelectedGroupingCondition(
    state
  ),
  textSearchConditions: assignPageSelectors.getTextSearchConditions(state),
  textSearchSuggetions: assignPageSelectors.getTextSearchSuggetions(state),
  isOnline: isOnlineSelector(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onNenkiChanged: (nenki: string) =>
    dispatch(assignPageActions.USER_CHNAGE_NENKI({ nenki })),
  onJobCreateButtonClicked: () =>
    dispatch(assignPageActions.USER_CLICKED_JOB_CREATE_BUTTON()),
  onJobUpdateButtonClicked: () =>
    dispatch(assignPageActions.USER_CLICKED_JOB_UPDATE_BUTTON()),
  onJobDeleteButtonClicked: () =>
    dispatch(assignPageActions.USER_CLICKED_JOB_DELETE_BUTTON()),
  USER_INSERT_ASSIGN: () => dispatch(assignPageActions.USER_INSERT_ASSIGN()),
  USER_DELETE_ASSIGN: () => dispatch(assignPageActions.USER_DELETE_ASSIGN()),
  onAssignSaveButtonClick: () =>
    dispatch(assignPageActions.USER_CLICKED_ASSIGN_SAVE_BUTTON()),
  USER_RELOAD_ASSIGNS_LIST: () =>
    dispatch(assignPageActions.USER_RELOAD_ASSIGNS_LIST({})),
  USER_RESET_ASSIGNS_LIST: () =>
    dispatch(assignPageActions.USER_RESET_ASSIGNS_LIST()),
  onGroupingConditionChanged: (key: AssignGroupingKey) =>
    dispatch(
      assignPageActions.USER_SELECT_GROUPING_CONDITION({ groupingKey: key })
    ),
  onRegisterCustomFilterButtonClick: () =>
    dispatch(assignPageActions.USER_CLICKED_CUSTOM_FILTER_REGISTER_BUTTON()),
  onFilterManagementButtonClick: () =>
    dispatch(assignPageActions.USER_CLICKED_FILTER_MANAGEMENT_BUTTON()),
  onTextSearchConditionChanged: (conditions: KeyValue[]) =>
    dispatch(assignPageActions.USER_CHANGE_TEXT_SEARCH_CONDITION(conditions)),
  onOpenChangeHistoryButtonClick: () =>
    dispatch(assignPageActions.USER_CLICKED_OPEN_CHANGE_HISTORY_BUTTON())
});

export const AssignCommandBar = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true } // BLOG https://github.com/reduxjs/react-redux/issues/914#issuecomment-459937227
)(AssignCommandBarComponent);
